import { useEffect, useRef } from "react";

/**
 * Зберігає останню подію beforeinstallprompt (Chrome/Android).
 * Без цього react-pwa-install міг «успішно» завершуватися без реальної установки.
 */
export function useInstallPromptRef() {
  const deferredPromptRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      deferredPromptRef.current = e;
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  return deferredPromptRef;
}
